import './CreateMenuSheet.sass';

import React, { FC, useCallback } from 'react';
import { List, ListItem } from '$uikit';
import {
  IcAddStory28,
  IcBundle24,
  IcCam28,
  IcCircle28,
  IcClips24,
  IcMessage28,
  IcWrite28,
} from '$assets';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { useCurrentUserInfo, useTranslator, useUserInfo } from '$hooks';
import { useWriteMessageCallback } from '$core/Im/Im';
import { showModal } from '$navigation/helper';
import { statReachGoal, choseFiles } from '$utils';
import { isCreateMenuShownSelector, mainActions } from '$store/main';
import { useDispatch, useSelector } from 'react-redux';
import { storiesActions } from '$store/stories';
import { useRoute } from 'react-router5';
import { FEED } from '$shared/constants/pages';

const CreateMenuSheetInner: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { router } = useRoute();
  const handleCreateMessageFn = useWriteMessageCallback();
  const user = useCurrentUserInfo();

  const handleCreateBundle = () => {
    dispatch(mainActions.setCreateMenuShown(false));
    showModal('create_bundle');
  };

  const handleCreatePost = () => {
    dispatch(mainActions.setCreateMenuShown(false));
    showModal('post');
  };

  const handleCreateClip = () => {
    dispatch(mainActions.setCreateMenuShown(false));
    showModal('reel');
  };

  const handleGoLive = () => {
    dispatch(mainActions.setCreateMenuShown(false));
    showModal('live');
    statReachGoal('live_create_from_creator_sheet');
  };

  const handleCreateMessage = () => {
    dispatch(mainActions.setCreateMenuShown(false));
    handleCreateMessageFn();
  };

  const handleCreateStory = useCallback(async () => {
    dispatch(mainActions.setCreateMenuShown(false));
    try {
      const files = await choseFiles(false);
      router.navigate(FEED);
      dispatch(storiesActions.uploadStory({ file: files[0] }));
    } catch {}
  }, [dispatch]);

  return (
    <BottomSheet
      className="CreateMenuSheet"
      title={t('create_content_menu_title')}
      scroll={false}
      onClose={() => dispatch(mainActions.setCreateMenuShown(false))}
    >
      <List>
        <ListItem onClick={handleCreateMessage} indicator={<IcMessage28 />}>
          {t('create_content_menu_message')}
        </ListItem>
        <ListItem onClick={handleCreatePost} indicator={<IcWrite28 />}>
          {t('create_content_menu_post')}
        </ListItem>
        <ListItem onClick={handleCreateStory} indicator={<IcAddStory28 />}>
          {t('create_content_menu_story')}
        </ListItem>
        {!user?.isolated && (
          <ListItem onClick={handleCreateClip} indicator={<IcClips24 />}>
            {t('create_content_menu_clip')}
          </ListItem>
        )}
        <ListItem onClick={handleCreateBundle} indicator={<IcBundle24 />}>
          {t('create_content_menu_bundle')}
        </ListItem>
        <ListItem
          onClick={handleGoLive}
          indicator={
            <span className="CreateMenuSheet__live">
              <IcCam28 />
            </span>
          }
        >
          {t('create_content_menu_live')}
        </ListItem>
      </List>
    </BottomSheet>
  );
};

export const CreateMenuSheet: FC = () => {
  const shown = useSelector(isCreateMenuShownSelector);
  return shown ? <CreateMenuSheetInner /> : null;
};
